import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  // Entrada do painel: surge deslizando da direita + fade. O painel só monta
  // quando a primeira IA é cadastrada, então a animação roda nessa aparição.
  '@keyframes panelEnter': {
    from: { opacity: 0, transform: 'translateX(24px)' },
    to: { opacity: 1, transform: 'translateX(0)' },
  },
  panel: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 0,
    borderRadius: 0,
    overflow: 'hidden',
    animation: '$panelEnter 400ms ease-out both',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 3),
    minHeight: theme.spacing(9),
  },
  title: {
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  list: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    padding: theme.spacing(2),
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    padding: theme.spacing(3),
  },
}))

export default useStyles
